<div class="bio-five">

    <h5> So come join me in my newest adventure from here to the bungalow! Choose your classic ride (1967 ford mustang anyone? Oh, we need more room? Let’s go for the 1968 VW van!), open the windows, and turn up the tunes. We’re heading to the coast with our green kodaks ready for the next thing to inspire a change in direction.</h5>

    <h5>I’ve got my truetone, you bring the map.</h5>
    
    </div>
